import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, TOKEN_KEY } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const target = location.pathname === "/" ? "/portal" : location.pathname;
    api
      .post("/auth/session", { session_id: sessionId })
      .then(({ data }) => {
        const { session_token, ...user } = data;
        if (session_token) localStorage.setItem(TOKEN_KEY, session_token);
        setUser(user);
        const dest = user.role === "admin" ? "/admin" : target;
        navigate(dest, { replace: true, state: { user } });
      })
      .catch(() => {
        toast.error("Sign-in didn't complete. Please try again.");
        navigate("/login", { replace: true });
      });
  }, [location, navigate, setUser]);

  return <div className="min-h-screen bg-[#0A0A0A]" data-testid="auth-callback" />;
}
